/** @format */

import setDeep from 'lodash/set';
export default {
  methods: {
    setDataDeep(obj, path, value) {
      // return setDeep(obj, path, value);
      const keys = path.split('.');
      let current = obj;

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];

        if (i === keys.length - 1) {
          current[key] = value;
        } else {
          if (typeof current[key] !== 'object' || current[key] === null) {
            current[key] = {};
          }
          current = current[key];
        }
      }

      return obj;
    },
    initModel(model, { value, values }) {
      const replaceInit = (obj, _values) => {
        if (obj && typeof obj === 'object') {
          for (const key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            const val = obj[key];
            // Если свойство - объект с "_: init"
            if (val && typeof val === 'object' && val._ === 'init') {
              // заменить на values по ключу value
              obj[key] = _values[val.value];
            } else {
              // рекурсивно пройти внутрь
              replaceInit(val, _values);
            }
          }
        }
      };
      let m = structuredClone(model);
      replaceInit(m, values);
      return m;
    },
    getObjectPath(o = {}, path) {
      const p = path.split('.');
      let tmp;
      for (let i = 0; i < p.length; i++) {
        const el = p[i];
        if (i === 0) {
          tmp = Object.assign({}, o || {});
        }
        tmp = tmp?.[el];
      }
      return tmp;
    },
    getFilters(model, { value, values }) {
      if (!(model && model.filters)) return false;
      const filters = {};
      if (typeof model.filters === 'object') {
        for (const key in model.filters) {
          const f = model.filters[key];
          if (f.type == 'field') {
            filters[key] = values[f.value];
          }
        }
      }
      return filters;
    },
    getInitData(model, { value, values }) {
      if (!(model && model.initData)) return false;
      const initData = {};
      if (typeof model.filters === 'object') {
        for (const key in model.initData) {
          const f = model.initData[key];
          if (f.type == 'field') {
            initData[key] = values[f.value];
          }
        }
      }
      return initData;
    },

    getDataForModel(model, data) {
      const result = {};
      const getValueByPath = (obj, path) => {
        return path.split('.').reduce((o, key) => {
          if (o && typeof o === 'object' && key in o) {
            return o[key];
          }
          return undefined;
        }, obj);
      };
      const setValueByPath = (obj, path, value) => {
        const keys = path.split('.');
        let current = obj;

        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            current[key] = value;
          } else {
            if (!current[key] || typeof current[key] !== 'object') {
              current[key] = {};
            }
            current = current[key];
          }
        });
      };

      model.forEach((field) => {
        const path = field.name;
        const value = getValueByPath(data, path);
        setValueByPath(result, path, value);
      });

      return result;
    },
  },
};
